import React from 'react';
import WorldMap from './WorldMap';

const GeographicView = () => {

  const handleCountryClick = (country) => {
    console.log('Country clicked:', country);
    // Additional handling can be added here
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8">
        <WorldMap onCountryClick={handleCountryClick} />
      </div>
    </div>
  );
};

export default GeographicView;
